import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Auth from "./router/auth";
import Layout from "./router/layout";
import VideoBluegecko from "./component/pages/landingpage/Video";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import styles
import { useIsAuthenticated } from "@azure/msal-react";

const App = () => {
  const isAuthenticated = useIsAuthenticated();
  // const [isAuthenticated, setIsAuthenticated] = useState(() => {
  //   return !!sessionStorage.getItem("jwtToken"); // Initialize from sessionStorage
  // });
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
    <Router>
      <ToastContainer position="top-right" autoClose={1500} />
      <Routes>
        <Route path="/" element={<VideoBluegecko />} />
        <Route
          path="/*"
          element={
            isAuthenticated ? (
              <Layout
                isOpen={isSidebarOpen}
                setIsOpen={setIsSidebarOpen}
              />
            ) : (
              <Auth />
            )
          }
        />
      </Routes>
    </Router>
  );
};

export default App;